import { useMediaQuery } from "@mui/system";
import { createContext, useState, useMemo, useEffect } from "react";

export const LayoutContext = createContext();

export default function LayoutProvider({ children }) {
  const isTablet = useMediaQuery("(max-width:999px)");

  const [collapsed, setCollapsed] = useState(isTablet ? true : false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const value = useMemo(
    () => ({ collapsed, setCollapsed, mobileOpen, setMobileOpen }),
    [collapsed, mobileOpen]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}
